/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge, Box, Image, VStack } from '@chakra-ui/react';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { getProductImageByType } from './utils';

const PLACEHOLDER_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3E%3Crect width='30' height='30' fill='%23e2e8f0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23a0aec0' font-size='12'%3E?%3C/text%3E%3C/svg%3E";

export const AgrementProductItem = ({ product }: { product: Product }) => {
  const { colors } = useTheme();
  const logoUrl = (product.metadata?.logo?.value as string)?.trim() || '';
  const fallbackUrl = getProductImageByType(product);
  const imageSrc = logoUrl || fallbackUrl || PLACEHOLDER_IMAGE;

  const name = product.name;

  return (
    <VStack spacing={1}>
      <Box position={'relative'} height={'100%'}>
        {product.default_product.id === 14 ? null : <Box
          position={'absolute'}
          mixBlendMode={'color'}
          width="100%"
          height={'100%'}
          borderRadius={{
            base: '12px',
            sm: '12px',
            md: '12px',
            lg: '24px',
          }}
          bg={colors.primaryColor}
        />}
        <Image
          src={imageSrc}
          alt={product.name}
          fallbackSrc={fallbackUrl || PLACEHOLDER_IMAGE}
          minWidth={'30px'}
          minHeight={'30px'}
          maxWidth={'30px'}
          maxHeight={'30px'}
          objectFit="contain"
        />
      </Box>

      <Badge
        colorScheme={
          product.default_product.name === 'Super App'
            ? 'blue'
            : product.default_product.name === 'Livro'
              ? 'green'
              : product.default_product.name === 'Revista'
                ? 'purple'
                : 'gray'
        }
        size="sm"
        variant="subtle"
      >
        {name}
      </Badge>
    </VStack>
  );
};

export default AgrementProductItem;
